import React, { useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import FullPageLoading from 'components/FullPageLoading'
import { CreatePerformer, PerformerType, UpdatePerformer } from 'generated/graphql'
import { useEventSlug } from 'hooks'
import { _, withCapture } from 'utils'
import FormTabs from '../forms/FormTabs'
import { showNotification } from '../notifications'
import { showErrorNotification } from '../notifications/notificationsSlice'
import AboutSpeaker from './tabs/AboutSpeaker'
import { createSpeaker, updateSpeaker } from './graphql/mutation'
import { getChangedValues } from '../forms/utils'

export const SpeakerValidation = Yup.object().shape({
    name: Yup.string().required().min(3),
})

interface SpeakerEditorProps {
  speaker?: PerformerType;
}
const SpeakerEditor = ({ speaker }: SpeakerEditorProps) => {
    const eventSlug = useEventSlug()
    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [initialValues, setInitialValues] = useState(speaker || {
        name: '',
    })

    const handleSubmit = withCapture(async (values, { resetForm }) => {
        setIsLoading(true)
        const submitValues = getChangedValues(initialValues, values)
        const response = !values.id ? await createSpeaker(eventSlug, submitValues as CreatePerformer)
            : await updateSpeaker(values.id, submitValues as UpdatePerformer)

        if (!response.data && response.errors) {
            dispatch(showErrorNotification(response.errors))
            setIsLoading(false)
            return
        }

        if (location.pathname.endsWith('/create')) {
            history.push(location.pathname.replace('/create', ''))
        }

        dispatch(showNotification({
            type: 'success',
            body: _('form.notification.update_success'),
        }))
        resetForm({ values })
        setInitialValues(values)
        setIsLoading(false)
    })

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={SpeakerValidation}
        >
            <>
                <FormTabs
                    tabs={[
                        { id: 'aboutSpeaker', name: _('show.tabs.about_speaker'), Component: AboutSpeaker },
                    ]}
                />
                {isLoading && <FullPageLoading isAbsolute />}
            </>
        </Formik>
    )
}

export default SpeakerEditor
